import styled, { css } from "styled-components"
import { themeColor } from "ui/theme"

export const SearchResultsTitle = ({
  query,
  count,
  hideOnMobile = false,
  hideOnDesktop = false,
  className,
}) => {
  return (
    <TitleSection
      className={className}
      hideOnMobile={hideOnMobile}
      hideOnDesktop={hideOnDesktop}>
      <PageTitle>{query}</PageTitle>
      <Subtitle>{count} instructors available</Subtitle>
    </TitleSection>
  )
}

const TitleSection = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-block: 1.5rem;

  ${({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}

  ${({ hideOnDesktop }) =>
    hideOnDesktop &&
    css`
      @media (min-width: 768px) {
        display: none;
        text-align: initial;
        margin-bottom: 0;
        gap: 2px;
      }
    `}
`

const PageTitle = styled.h1`
  font-family: Montserrat, sans-serif;
  font-size: 1.75rem;
  font-weight: 400;
  color: ${themeColor("txt")};
  margin: 0;

  @media (min-width: 768px) {
    font-family: Poppins, sans-serif;
    text-align: initial;
    font-size: 1.5rem;
  }
`

const Subtitle = styled.p`
  font-family: Montserrat, sans-serif;
  font-size: 0.9rem;
  color: ${themeColor("txt")};
  font-weight: 400;
  opacity: 0.6;
  margin: 0;

  @media (min-width: 768px) {
    font-family: Poppins, sans-serif;
    font-size: 0.875rem;
    opacity: 0.7;
  }
`